const Footer = () => {
    return (
      <div
        style={{
          textAlign: "center",
          marginBottom: 10,
        }}
      >
        Made with ♥ by{" "}
        <a
          href="https://github.com/14harshjaiswal"
          style={{ cursor: "pointer" }}
        >
          Harsh Jaiswal
        </a>
      </div>
    );
  };
  
  export default Footer;
  